// Gallery modal - Handle image navigation and thumbnails
(function() {
  'use strict';

  class GalleryController {
    constructor() {
      this.state = new WeakMap();
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupListeners());
      } else {
        this.setupListeners();
      }
    }

    setupListeners() {
      const modals = document.querySelectorAll('.product-media-modal');

      modals.forEach((modal) => {
        const observer = new MutationObserver(() => {
          if (modal.hasAttribute('open')) {
            setTimeout(() => this.initModal(modal), 50);
          }
        });

        observer.observe(modal, { attributes: true });

        if (modal.hasAttribute('open')) {
          this.initModal(modal);
        }
      });
    }

    initModal(modal) {
      const contentDiv = modal.querySelector('.product-media-modal__content');
      if (!contentDiv) return;

      const mediaItems = this.getMediaItems(contentDiv);
      if (mediaItems.length === 0) return;

      const openerId = modal.openedBy && modal.openedBy.getAttribute('data-media-id');
      let currentIndex = 0;

      if (openerId) {
        const openerIndex = mediaItems.findIndex(
          (item) => item.getAttribute('data-media-id') === openerId
        );
        if (openerIndex >= 0) currentIndex = openerIndex;
      } else {
        const activeIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        if (activeIndex >= 0) currentIndex = activeIndex;
      }

      const useSlick = !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.slick);
      if (useSlick) {
        contentDiv.classList.add('use-slick');
      }
      if (!useSlick) {
        modal._gallerySlickRetry = modal._gallerySlickRetry || 0;
        if (modal._gallerySlickRetry < 3) {
          modal._gallerySlickRetry += 1;
          setTimeout(() => this.initModal(modal), 200);
        }
      }
      if (useSlick && contentDiv.offsetWidth === 0) {
        modal._galleryInitRetry = modal._galleryInitRetry || 0;
        if (modal._galleryInitRetry < 3) {
          modal._galleryInitRetry += 1;
          setTimeout(() => this.initModal(modal), 120);
        }
        return;
      }
      const $content = useSlick ? window.jQuery(contentDiv) : null;
      this.state.set(modal, { mediaItems, currentIndex, useSlick, $content });

      //const prevBtn = modal.querySelector('.gallery-nav--prev');
      //const nextBtn = modal.querySelector('.gallery-nav--next');
      const prevBtn = `<button type="button" class="slick-prev slick-arrow" aria-label="Previous">
                      <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0.5)" fill="currentColor"/>
                        <path d="M22.6875 26.375L16.3125 20L22.6875 13.625" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </button>`;
      const nextBtn = `<button type="button" class="slick-next slick-arrow" aria-label="Next">
                      <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="20" cy="20.5" r="20" fill="currentColor"/>
                        <path d="M17.3125 26.375L23.6875 20L17.3125 13.625" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>`;
      const thumbnails = modal.querySelectorAll('.gallery-thumbnail');
      const mainMedia = modal.querySelector('.product-media-modal__gallery-main');

      /*if (prevBtn) {
        prevBtn.onclick = (e) => {
          e.preventDefault();
          this.previousImage(modal);
        };
      }

      if (nextBtn) {
        nextBtn.onclick = (e) => {
          e.preventDefault();
          this.nextImage(modal);
        };
      }*/

      thumbnails.forEach((thumb) => {
        thumb.onclick = (e) => {
          e.preventDefault();
          const mediaId = thumb.getAttribute('data-media-id');
          this.goToImageById(mediaId, modal);
        };
      });

      if (useSlick) {
        if ($content && !$content.hasClass('slick-initialized')) {
          $content.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            swipe: true,
            adaptiveHeight: false,
            variableWidth: false,
            centerMode: false,
            prevArrow: prevBtn || undefined,
            nextArrow: nextBtn || undefined,
            responsive: [
            {
              breakpoint: 989,
              settings: {
                arrows: false
              }
            }
          ]
          });

          $content.on('afterChange.galleryModal', (event, slick, currentSlide) => {
            this.syncThumbnails(modal, currentSlide);
          });
        } else if ($content && $content.hasClass('slick-initialized')) {
          $content.slick('setPosition');
        }

        if ($content) {
          $content.slick('slickGoTo', currentIndex, true);
          setTimeout(() => {
            $content.slick('setPosition');
          }, 0);
        }
        const updatedItems = this.getMediaItems(contentDiv);
        if (updatedItems.length) {
          const state = this.state.get(modal);
          if (state) state.mediaItems = updatedItems;
        }
        this.syncThumbnails(modal, currentIndex);

        if (!modal._galleryResizeHandler) {
          modal._galleryResizeHandler = () => {
            if (!modal.hasAttribute('open')) return;
            const state = this.state.get(modal);
            if (state && state.useSlick && state.$content) {
              state.$content.slick('setPosition');
            }
          };
          window.addEventListener('resize', modal._galleryResizeHandler);
        }
        return;
      }

      if (mainMedia && !modal._galleryTouchHandler) {
        modal._galleryTouchHandler = {
          startX: 0,
          startY: 0
        };

        mainMedia.addEventListener(
          'touchstart',
          (e) => {
            if (!modal.hasAttribute('open')) return;
            const touch = e.touches && e.touches[0];
            if (!touch) return;
            modal._galleryTouchHandler.startX = touch.clientX;
            modal._galleryTouchHandler.startY = touch.clientY;
          },
          { passive: true }
        );

        mainMedia.addEventListener(
          'touchend',
          (e) => {
            if (!modal.hasAttribute('open')) return;
            const touch = e.changedTouches && e.changedTouches[0];
            if (!touch) return;
            const deltaX = touch.clientX - modal._galleryTouchHandler.startX;
            const deltaY = touch.clientY - modal._galleryTouchHandler.startY;
            if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
            if (deltaX > 0) {
              this.previousImage(modal);
            } else {
              this.nextImage(modal);
            }
          },
          { passive: true }
        );
      }

      if (!modal._galleryKeyHandler) {
        modal._galleryKeyHandler = (e) => {
          if (!modal.hasAttribute('open')) return;
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.previousImage(modal);
          }
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.nextImage(modal);
          }
        };
        document.addEventListener('keydown', modal._galleryKeyHandler);
      }

      this.updateDisplay(modal);
    }

    previousImage(modal) {
      const state = this.state.get(modal);
      if (!state || state.mediaItems.length === 0) return;
      if (state.useSlick && state.$content) {
        state.$content.slick('slickPrev');
        return;
      }
      state.currentIndex =
        (state.currentIndex - 1 + state.mediaItems.length) % state.mediaItems.length;
      this.updateDisplay(modal);
    }

    nextImage(modal) {
      const state = this.state.get(modal);
      if (!state || state.mediaItems.length === 0) return;
      if (state.useSlick && state.$content) {
        state.$content.slick('slickNext');
        return;
      }
      state.currentIndex = (state.currentIndex + 1) % state.mediaItems.length;
      this.updateDisplay(modal);
    }

    goToImageById(mediaId, modal) {
      if (!mediaId) return;
      const state = this.state.get(modal);
      if (!state) return;
      if (state.mediaItems.length === 0) {
        const contentDiv = modal.querySelector('.product-media-modal__content');
        if (contentDiv) state.mediaItems = this.getMediaItems(contentDiv);
      }
      const index = state.mediaItems.findIndex(
        (item) => item.getAttribute('data-media-id') === mediaId
      );
      if (index < 0) return;
      if (state.useSlick && state.$content) {
        state.$content.slick('slickGoTo', index);
        return;
      }
      state.currentIndex = index;
      this.updateDisplay(modal);
    }

    updateDisplay(modal) {
      const state = this.state.get(modal);
      if (!state) return;
      if (state.mediaItems.length === 0) {
        const contentDiv = modal.querySelector('.product-media-modal__content');
        if (contentDiv) state.mediaItems = this.getMediaItems(contentDiv);
      }
      if (state.useSlick) {
        this.syncThumbnails(modal, state.currentIndex);
        return;
      }

      state.mediaItems.forEach((item, index) => {
        item.classList.toggle('active', index === state.currentIndex);
      });

      const thumbnails = modal.querySelectorAll('.gallery-thumbnail');
      const currentItem = state.mediaItems[state.currentIndex];
      if (!currentItem) return;
      thumbnails.forEach((thumb) => {
        const mediaId = thumb.getAttribute('data-media-id');
        const isActive =
          mediaId && currentItem.getAttribute('data-media-id') === mediaId;
        thumb.classList.toggle('active', isActive);
      });

      this.scrollActiveThumbnail(modal);
    }

    syncThumbnails(modal, currentIndex) {
      const state = this.state.get(modal);
      if (!state) return;
      if (state.mediaItems.length === 0) {
        const contentDiv = modal.querySelector('.product-media-modal__content');
        if (contentDiv) state.mediaItems = this.getMediaItems(contentDiv);
      }
      state.currentIndex = currentIndex;
      const currentItem = state.mediaItems[currentIndex];
      if (!currentItem) return;
      const thumbnails = modal.querySelectorAll('.gallery-thumbnail');
      thumbnails.forEach((thumb) => {
        const mediaId = thumb.getAttribute('data-media-id');
        const isActive =
          mediaId && currentItem.getAttribute('data-media-id') === mediaId;
        thumb.classList.toggle('active', isActive);
      });
      this.scrollActiveThumbnail(modal);
    }

    scrollActiveThumbnail(modal) {
      const thumbnailsWrapper = modal.querySelector('.gallery-thumbnails');
      const activeThumbnail = modal.querySelector('.gallery-thumbnail.active');
      if (thumbnailsWrapper && activeThumbnail) {
        activeThumbnail.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }

    getMediaItems(contentDiv) {
      const items = Array.from(contentDiv.querySelectorAll('[data-media-id]'));
      return items.filter((item) => !item.classList.contains('slick-cloned'));
    }
  }

  new GalleryController();
})();
